import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useGlobal from '../../../store';
import Container from '../../components/container';
import { TARIFF_FEATURES, TARIFF_FEATURE_PATH, accessLevel, featureAllowed } from '../../../settings/tariff.features';
import './tariff.required.scss';

const PAYMENT_OFF = 'Онлайн-оплата ещё не включена. Напишите в поддержку';

const TariffRequired = () => {

  const navigate = useNavigate();
  const [ params ] = useSearchParams();
  const feature = params.get('feature') || '';
  const known = Object.prototype.hasOwnProperty.call(TARIFF_FEATURES, feature);

  const [ globalState, globalActions ] = useGlobal();
  const { user_id, user_role, tariff } = globalState;
  const role = Number(user_role);
  const seesMoney = role === 1 || role === 2;
  const opened = known && featureAllowed(accessLevel(tariff), feature);

  const [ loading, setLoading ] = useState(true);
  const [ error, setError ] = useState('');
  const [ requiredTariff, setRequiredTariff ] = useState(null);
  const [ notice, setNotice ] = useState('');
  const [ supportOpen, setSupportOpen ] = useState(false);

  useEffect(() => {

    if (!known) navigate('/', { replace: true });

  }, [ known, navigate ]);

  useEffect(() => {

    if (!user_id || !opened) return;
    navigate(TARIFF_FEATURE_PATH[ feature ] || '/', { replace: true });

  }, [ user_id, opened, feature, navigate ]);

  useEffect(() => {

    if (!user_id || !known) return;

    let cancelled = false;

    globalActions.tariff.required(feature).then((result) => {

      if (cancelled) return;
      setLoading(false);

      if (!result.success) {
        setError(result.text || 'Не удалось проверить тариф');
        return;
      }

      setRequiredTariff(result.data.required || null);

    });

    return () => { cancelled = true; };

  }, [ user_id, known, feature ]);

  function writeSupport() {

    setSupportOpen(true);

  }

  const title = requiredTariff && requiredTariff.name
    ? `Вам нужен тариф ${requiredTariff.name}`
    : 'Обратитесь в поддержку';

  return (

    <Container>

      <div className = "tariff-required">

        { !known ? null : (

          <div>

            <h1>{ !user_id || loading ? 'Загрузка...' : title }</h1>

            { known ? <p>{ TARIFF_FEATURES[ feature ].title }</p> : null }

            { known ? (

              <img
                className = "tariff-required__shot"
                src = { TARIFF_FEATURES[ feature ].image }
                alt = { TARIFF_FEATURES[ feature ].title }
              />

            ) : null }

            { error ? <p>{ error }</p> : null }

            { !loading && !requiredTariff ? <p>Обратитесь в поддержку</p> : null }

            { notice ? <p>{ notice }</p> : null }

            <div className = "tariff-required__actions">

              { seesMoney && requiredTariff ? (

                <button type = "button" onClick = { () => setNotice(PAYMENT_OFF) }>Оплатить</button>

              ) : null }

              <button type = "button" onClick = { writeSupport }>Написать в поддержку</button>

            </div>

            { supportOpen ? (

              <div className = "tariff-required__support">

                <a href = "https://t.me/senior_rikky" target = "_blank" rel = "noreferrer">Telegram @senior_rikky</a>
                <a href = "https://wa.me/79953666777" target = "_blank" rel = "noreferrer">WhatsApp +7 995 366-67-77</a>

              </div>

            ) : null }

          </div>

        )}

      </div>

    </Container>

  );

};

export default TariffRequired;
